import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AccountService  {
    constructor(private http: Http) { }

    get(): Observable<any> {
        return this.http.get('api/account', { withCredentials: true }).map((res: Response) => res.json());
    }

    save(account: any): Observable<Response> {
        account.birthDate = new Date(Date.UTC(account.birthDate.getFullYear(), account.birthDate.getMonth(), account.birthDate.getDate()));
        return this.http.post('api/account', account);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/auth/account.service.ts